import RotateRight from "@mui/icons-material/RotateRight";
import { Handle, type NodeProps, Position } from "@xyflow/react";

import type { ContinueSentinelRuleNode } from "./loopTypes";
import LoopSentinelCard from "./LoopSentinelCard";

type ContinueSentinelNodeProps = NodeProps<ContinueSentinelRuleNode>;

const ContinueSentinelNode = ({ selected }: ContinueSentinelNodeProps) => (
	<LoopSentinelCard
		icon={<RotateRight fontSize="small" />}
		accentColor="#00838F"
		gradId="coapp-grad-primary"
		label="Loop Continue"
		title="Continue"
		badge="Next iteration"
		description="Loop body completes here, then returns to Start"
		selected={selected}
	>
		<Handle type="target" position={Position.Top} id="in" isConnectable />
		<Handle type="source" position={Position.Left} id="out" isConnectable={false} />
	</LoopSentinelCard>
);

export default ContinueSentinelNode;
